import PlatformTestScenarios from './PlatformTestScenarios'

/* eslint-disable camelcase, no-await-in-loop */
export default class PLAYTECHTestScenarios extends PlatformTestScenarios {
  async bet_settleWin_settleWin_settleWin() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet()

        await this.requests.settleWin({ data: { isEndRound: false } })
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.settleWin({ data: { isEndRound: false } })
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.settleWin({ data: { isEndRound: true } })
        await this.requests.getBalance({ action: 'settle' })
      },
    )
  }

  async multiBets_bet1_bet2_settleWin() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()

        const BET_LENGTH = 2
        const betIndexes = []
        for (let betIndex = 0; betIndex < BET_LENGTH; betIndex += 1) {
          await this.requests.bet({ betIndexes: [betIndex], data: { isMultiBets: true } })
          betIndexes.push(betIndex)
        }

        await this.requests.settleWin({ betIndexes })
        await this.requests.getBalance({ action: 'settle' })
      },
    )
  }
}
